<script setup lang="ts">
import { useConfigStore } from '../Stores/config'
import { PostmessageExternalSender } from '../postmessage-api-external'
import SubmitButton from './SubmitButton.vue'

const configStore = useConfigStore()
const close = (): void => new PostmessageExternalSender().close()
</script>

<template>
    <SubmitButton v-if="configStore.isKbcOrEnergyAtHomePartner" @click="close">
        {{ $t('Close') }}
    </SubmitButton>
</template>
